export const Favorite = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        width={'100%'}
        height={'100%'}
    >
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M12.487 13.475C13.64 12.513 15.122 12 16.66 12c1.94 0 3.772.787 5.158 2.183l2.27 2.29 2.272-2.29C27.746 12.787 29.578 12 31.518 12c1.529 0 3.009.513 4.16 1.462l.003.003a6.852 6.852 0 0 1 2.48 5.527c-.055 1.83-.894 3.52-2.139 4.776L25.453 34.431l-.003.003a1.943 1.943 0 0 1-2.61.12.997.997 0 0 1-.134-.114L11.985 23.635a6.95 6.95 0 0 1-1.978-5.176v-.005a6.865 6.865 0 0 1 2.48-4.98Zm11.59 19.502L34.603 22.36c.942-.95 1.523-2.175 1.56-3.428a4.852 4.852 0 0 0-1.76-3.929C33.628 14.365 32.604 14 31.518 14c-1.387 0-2.713.559-3.738 1.592l-2.318 2.336-.003.003a1.942 1.942 0 0 1-2.74 0l-.004-.003-2.317-2.336C19.373 14.559 18.046 14 16.66 14c-1.098 0-2.12.366-2.892 1.01a4.867 4.867 0 0 0-1.763 3.542 4.95 4.95 0 0 0 1.404 3.679l.001.001 10.63 10.714.038.031Z"
            clipRule="evenodd"
        />
    </svg>
);
